import React, { useCallback, useEffect, useState } from "react";
import Select from "react-select";
import { apiKey } from "../../config/config";
import axios from "axios";
import MessageCard from "../AdminCards/MessageCard";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { languageHelper } from "../../config/helperFunctions";

function LocationModal({ closeModal }) {
  const [selectedOrderType, setSelectedOrderType] = useState(2);
  const [outlets, setOutlets] = useState([]);
  const [selectedArea, setSelectedArea] = useState(null);
  const [selectedOutletObj, setSelectedOutletObj] = useState(null);
  const [selectedDeliveryPrice, setSelectedDeliveryPrice] = useState(0);
  const [error, setError] = useState(false);

  const handleSelect = () => {
    if (!selectedOutletObj || !selectedArea) {
      setError("Area Required!");
      return;
    }

    const data = {
      orderType: selectedOrderType,
      outlet: selectedOutletObj,
      area: selectedArea,
      delivery_price: selectedDeliveryPrice,
      outlet_id: selectedOutletObj.id,
    };
    localStorage.setItem("rms-outlet", JSON.stringify(data));

    // Dispatch a custom event
    window.dispatchEvent(new Event("storageUpdated"));
    closeModal();
  };

  const fetchOutlets = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/customer/get-outlets`, {
        params: {
          orderTypeId: selectedOrderType,
          activeOrdertypes: true,
        },
      })
      .then((res) => {
        setOutlets(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedOrderType]);

  useEffect(() => {
    fetchOutlets();
  }, [fetchOutlets]);

  const areaOptions = React.useMemo(() => {
    const options = [];
    outlets.forEach((outlet) => {
      try {
        if (outlet.areas) {
          const parsedAreas = JSON.parse(outlet.areas);
          parsedAreas.forEach((item) => {
            const areaName = typeof item === "string" ? item : item.area;
            const price = typeof item === "string" ? 0 : (item.delivery_price || 0);
            options.push({ areaName: areaName, outlet: outlet, price: price });
          });
        }
      } catch (e) {
        console.error(e);
      }
    });
    return options;
  }, [outlets]);
  return (
    <>
      <div className="w-screen min-h-screen overlfow-y-scroll fixed top-0 left-0 backdrop-blur-2xl bg-black bg-opacity-40 z-50 grid place-items-center">
        <div className="bg-white max-w-2xl w-full overflow-y-auto rounded-xl px-2 py-4">
          <div className="my-2">
            <img className="mx-auto w-36" src="/imdady_logo.png" alt="" />
          </div>
          <div className="my-4 w-full">
            <h1 className="font-bold text-center text-w-heading">
              {languageHelper("select your order type") ||
                "Select your order type"}
            </h1>
            <div className="w-full my-4">
              <div className="w-full">
                <div className="flex justify-center gap-2 text-w-heading">
                  {/* <button
                    className={`p-2 rounded border border-w-border ${
                      selectedOrderType === 1 &&
                      "bg-w-btn border-none text-w-btn-text"
                    }`}
                    onClick={() => setSelectedOrderType(1)}
                  >
                    {languageHelper("dine-in")}
                  </button> */}
                  <button
                    className={`p-2 rounded border border-w-border ${selectedOrderType === 2 &&
                      "bg-w-btn border-none text-w-btn-text"
                      }`}
                    onClick={() => setSelectedOrderType(2)}
                  >
                    {languageHelper("delivery") || "DELIVERY"}
                  </button>
                  {/* <button
                    className={`p-2 rounded border border-w-border ${selectedOrderType === 3 &&
                      "bg-w-btn border-none text-w-btn-text"
                      }`}
                    onClick={() => setSelectedOrderType(3)}
                  >
                    {languageHelper("takeaway") || "TAKEAWAY"}
                  </button> */}
                </div>
                <div className="my-4 w-full">
                  <div className="max-w-md mx-auto">
                    <h2 className="text-center text-w-heading font-medium">
                      {selectedOrderType === 2
                        ? languageHelper("please select your location") ||
                        "Please select your location"
                        : selectedOrderType === 1
                          ? languageHelper(
                            "which outlet would you like to dine-in?"
                          ) || "Which outlet would you like to dine-in?"
                          : languageHelper(
                            "which outlet would you like to pick-up from?"
                          ) || "Which outlet would you like to pick-up from?"}
                    </h2>
                    <button className="flex gap-2 items-center justify-center rounded-full bg-gray-100 px-6 my-2 py-1 mx-auto text-sm text-gray-600 hover:bg-w-btn hover:text-w-btn-text group">
                      <span>
                        <FaLocationCrosshairs />
                      </span>
                      <span>
                        {languageHelper("use current location") ||
                          "Use Current Location"}
                      </span>
                    </button>
                    <div>
                      <form action="">
                        <Select
                          options={areaOptions.map(opt => ({
                            value: `${opt.outlet.id}|${opt.areaName}|${opt.price || 0}`,
                            label: opt.areaName
                          }))}
                          placeholder={languageHelper("Select Area") || "Select Area"}
                          onChange={(selectedOption) => {
                            if (selectedOption) {
                              const val = selectedOption.value;
                              const parts = val.split("|");
                              const outletIdStr = parts[0];
                              const priceStr = parts[parts.length - 1];
                              const areaName = parts.slice(1, -1).join("|");
                              const matchedOutlet = outlets.find(o => String(o.id) === String(outletIdStr));
                              setSelectedArea(areaName);
                              setSelectedOutletObj(matchedOutlet);
                              setSelectedDeliveryPrice(Number(priceStr));
                            } else {
                              setSelectedArea(null);
                              setSelectedOutletObj(null);
                              setSelectedDeliveryPrice(0);
                            }
                          }}
                          className="w-full text-left my-4 text-gray-700 font-medium"
                          isClearable
                        />
                        {error && <MessageCard error={error} />}
                        <button
                          type="button"
                          className={`w-full text-center rounded-md p-2 my-2 text-w-btn-text bg-w-btn`}
                          onClick={handleSelect}
                        >
                          {languageHelper("select") || "Select"}
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LocationModal;
